import { FullStory, Datadog, DataLayer } from 'V2/Analytics';

export const identify = (id: string) => {
  FullStory.identify(id);
  Datadog.identify(id);

  DataLayer.push({
    event: 'marketing_id',
    marketing_id: id,
  });
};
